(() => {
  const heroes = document.querySelectorAll('.bud-hero-v2');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  heroes.forEach((hero) => {
    let frame = null;
    let mobileFrame = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const render = () => {
      currentX += (targetX - currentX) * 0.12;
      currentY += (targetY - currentY) * 0.12;

      hero.style.setProperty('--bud-cursor-x', currentX.toFixed(4));
      hero.style.setProperty('--bud-cursor-y', currentY.toFixed(4));
      hero.style.setProperty('--bud-pouch-x', `${(-currentX * 12).toFixed(2)}px`);
      hero.style.setProperty('--bud-pouch-y', `${(-currentY * 8).toFixed(2)}px`);
      hero.style.setProperty('--bud-pouch-rot', `${(-1.2 + currentX * 1.6).toFixed(3)}deg`);
      hero.style.setProperty('--bud-berries-x', `${(currentX * 16).toFixed(2)}px`);
      hero.style.setProperty('--bud-berries-y', `${(currentY * 10).toFixed(2)}px`);
      hero.style.setProperty('--bud-berries-rot', `${(currentX * 2.2).toFixed(3)}deg`);
      hero.style.setProperty('--bud-bg-x', '0px');
      hero.style.setProperty('--bud-bg-y', '0px');

      if (Math.abs(targetX - currentX) > 0.001 || Math.abs(targetY - currentY) > 0.001) {
        frame = requestAnimationFrame(render);
      } else {
        frame = null;
      }
    };

    const start = () => {
      if (!frame) frame = requestAnimationFrame(render);
    };

    const mobileLoop = (time) => {
      const t = time / 1000;
      targetX = Math.sin(t * 0.86) * 0.56 + Math.sin(t * 1.47) * 0.14;
      targetY = Math.cos(t * 1.05) * 0.5;
      hero.classList.add('bud-hero-v2--active');
      start();
      mobileFrame = requestAnimationFrame(mobileLoop);
    };

    if (mobileQuery.matches && !prefersReducedMotion) {
      mobileFrame = requestAnimationFrame(mobileLoop);
    }

    mobileQuery.addEventListener?.('change', (event) => {
      if (event.matches && !prefersReducedMotion && !mobileFrame) {
        mobileFrame = requestAnimationFrame(mobileLoop);
      } else if (!event.matches && mobileFrame) {
        cancelAnimationFrame(mobileFrame);
        mobileFrame = null;
        targetX = 0;
        targetY = 0;
        hero.classList.remove('bud-hero-v2--active');
        start();
      }
    });

    hero.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch' || mobileQuery.matches) return;

      const rect = hero.getBoundingClientRect();
      targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      hero.classList.add('bud-hero-v2--active');
      start();
    });

    hero.addEventListener('pointerleave', () => {
      if (mobileQuery.matches) return;
      targetX = 0;
      targetY = 0;
      hero.classList.remove('bud-hero-v2--active');
      start();
    });
  });
})();
